import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Formik, Form } from "formik";
import Swal from "sweetalert2";
import { Button, Grid, Box } from "@mui/material";
import {
  fetchAddUsuario,
  fetchGetAllInmobiliarias,
  initializeMensaje,
} from "../../action";
import FormUsuarioFields from "./FormUsuarioFields";
import util from "../../utils/utilsFunctions";
import "../../css/styles.css";

const validate = (formValues) => {
  const errors = {};

  if (!formValues.Nombres) {
    errors.Nombres = "Por favor ingrese sus nombres";
  }

  if (!formValues.Apellidos) {
    errors.Apellidos = "Por favor ingrese sus apellidos";
  }

  if (formValues.Rut) {
    const rutError = util.checkRut(formValues.Rut);
    if (rutError) {
      errors.Rut = rutError;
    }
  } else {
    errors.Rut = "Por favor ingrese su rut";
  }

  if (!formValues.Telefono) {
    errors.Telefono = "Por favor ingrese su teléfono";
  } else if (isNaN(formValues.Telefono)) {
    errors.Telefono = "Por favor solo agregue números";
  }

  if (!formValues.Direccion) {
    errors.Direccion = "Por favor ingrese su dirección";
  }

  if (!formValues.Email) {
    errors.Email = "Por favor ingrese su email";
  }

  if (formValues.TipoCuenta === "" || formValues.TipoCuenta === undefined) {
    errors.TipoCuenta = "Por favor ingrese su tipo de cuenta";
  }

  if (!formValues.Password) {
    errors.Password = "Por favor ingrese su contraseña";
  }

  return errors;
};

const AgregarUsuario = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const itemInmobiliarias = useSelector(
    (state) => state.app.itemInmobiliarias || []
  );
  const requestAddUsuario = useSelector(
    (state) => state.app.requestAddUsuario
  );
  const errorMessage = useSelector((state) => state.app.errorMessage);

  let userLogueado = null;
  try {
    userLogueado = JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    userLogueado = null;
  }

  useEffect(() => {
    dispatch(initializeMensaje());
    dispatch(fetchGetAllInmobiliarias());
  }, [dispatch]);

  useEffect(() => {
    if (requestAddUsuario === "LOADING") {
      Swal.showLoading();
    } else if (requestAddUsuario === "SUCCESS") {
      Swal.fire({
        icon: "success",
        title: "Excelente",
        text: "Usuario agregado correctamente",
      }).then(() => {
        history.push("/usuarios");
      });
    } else if (requestAddUsuario === "ERROR") {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: errorMessage || "Ha ocurrido un error al agregar el usuario",
      });
    }
  }, [requestAddUsuario, errorMessage, history]);

  const handleSubmit = (values) => {
    const data = {
      fechaNacimiento: values.FechaNacimiento,
      tipoCuenta: values.TipoCuenta,
      apellidos: values.Apellidos,
      direccion: values.Direccion,
      nombres: values.Nombres,
      oficio: values.Oficio,
      inmobiliariaId: values.InmobiliariaId,
      proyectosInmobiliariosId: values.ProyectosInmobiliariosId,
      rut: values.Rut,
      telefono: values.Telefono,
      email: values.Email,
      datosBancarios: {
        banco: values.Banco,
        tipoCuenta: values.TipoCuentaBancaria,
        numeroCuenta: values.NumeroCuenta,
        medioPago: values.MedioPago,
      },
      password: values.Password,
    };
    dispatch(fetchAddUsuario(data));
  };

  const isAgenteView = userLogueado && userLogueado.tipoCuenta === 6;

  return (
    <div className="contenido">
      <div className="header">
        <h2>{isAgenteView ? "Crear Agente" : "Crear Usuario"}</h2>
      </div>

      <Formik
        initialValues={{
          Nombres: "",
          Apellidos: "",
          Rut: "",
          FechaNacimiento: "",
          Telefono: "",
          Direccion: "",
          Email: "",
          Oficio: "",
          Password: "",
          ProyectosInmobiliariosId: [],
          InmobiliariaId: "",
          TipoCuenta: "",
          Banco: "",
          TipoCuentaBancaria: "",
          NumeroCuenta: "",
          MedioPago: "",
        }}
        validate={validate}
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, handleChange, handleBlur, setFieldValue, isSubmitting }) => (
          <Form>
            <FormUsuarioFields
              values={values}
              errors={errors}
              touched={touched}
              handleChange={handleChange}
              handleBlur={handleBlur}
              setFieldValue={setFieldValue}
              itemInmobiliarias={itemInmobiliarias}
              isEdit={false}
            />

            <Box sx={{ mt: 2, mb: 4, display: "flex", gap: 2 }}>
              <button className="boton" type="submit" disabled={isSubmitting}>
                {isAgenteView ? "Crear Agente" : "Crear Usuario"}
              </button>
              <button
                type="button"
                className="boton"
                style={{ backgroundColor: "#6c757d" }}
                onClick={() => history.push("/usuarios")}
              >
                Cancelar
              </button>
            </Box>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default AgregarUsuario;
